import styled, {css} from "styled-components";
import imgButton from "@PUBLIC/M/images/btn/btn_spr.png";

const IconButton = styled.button<{icon: string; isActive?: boolean}>`
	${props => {
		if (props.icon === "share") {
			return css`
				width: 22px;
				height: 21px;
				background: url(${imgButton}) -47px -79px / 100px 100px no-repeat;
				z-index: 1;
			`;
		}

		if (props.icon === "wishList") {
			return css`
				width: 23px;
				height: 20px;
				background-image: url(${imgButton});
				background-size: 100px 100px;
				background-color: transparent;
				background-position: ${props.isActive ? "-70px -80px" : "-23px -80px"};
				z-index: 1;
			`;
		}
	}}
`;

export default IconButton;
